module.exports = __webpack_public_path__ + "img/web2_2.f64c0af8.jpg";